

































import Vue from 'vue'
import Component from 'vue-class-component'
import DataTable from '../components/DataTable.vue'
import AlgorithmCrud from '../components/AlgorithmCrud.vue'
import {
  RuleEngineAlgorithm,
  DataTableAction
} from '../utils/types'
import { Action, Getter } from 'vuex-class'
import { DataTableHeader } from 'vuetify'
import { translate } from '../utils/helpers'

@Component({
  components: { DataTable, AlgorithmCrud }
})
export default class Rules extends Vue {
  @Action createRuleEngineAlgorithm!: (
    payload: RuleEngineAlgorithm
  ) => Promise<boolean>

  @Action fetchRuleEngineAlgorithms!: (isActive: boolean) => Promise<void>
  @Action updateRuleEngineAlgorithm!: (algorithm: RuleEngineAlgorithm) => Promise<boolean>
  @Getter ruleEngineAlgorithms!: RuleEngineAlgorithm[]

  algorithmHeaders: DataTableHeader[] = [
    { text: 'שם', value: 'name' },
    { text: 'טריגר', value: 'trigger' }
  ]

  algorithmSavedMessage = ''
  areAlgorithmsActive = true
  currentAlgorithm: RuleEngineAlgorithm | null = null
  isCrudDialogVisible = false
  isLoading = false

  async mounted () {
    this.loadAlgorithms(true)
  }

  editAlgorithm (algorithm: RuleEngineAlgorithm) {
    this.currentAlgorithm = this.ruleEngineAlgorithms.find(alg => alg.id === algorithm.id) || algorithm
    this.isCrudDialogVisible = true
  }

  async handleTableTabChanged (tab: number) {
    this.areAlgorithmsActive = !tab
    await this.loadAlgorithms(!tab)
  }

  async loadAlgorithms (isActive: boolean): Promise<void> {
    this.isLoading = true
    try {
      await this.fetchRuleEngineAlgorithms(isActive)
    } finally {
      this.isLoading = false
    }
  }

  openCreateAlgorithmDialog () {
    this.currentAlgorithm = null
    this.isCrudDialogVisible = true
  }

  async saveAlgorithm (algorithm: RuleEngineAlgorithm) {
    let savedSuccessfully = false
    if (this.currentAlgorithm) {
      algorithm.id = this.currentAlgorithm.id
      savedSuccessfully = await this.updateRuleEngineAlgorithm(algorithm)
    } else {
      savedSuccessfully = await this.createRuleEngineAlgorithm(algorithm)
    }
    this.algorithmSavedMessage = savedSuccessfully
      ? 'האלגוריתם נשמר בהצלחה'
      : 'בעיה לא צפויה קרתה. אנא נסו שוב מאוחר יותר'
    this.isCrudDialogVisible = false
    this.currentAlgorithm = null
    await this.loadAlgorithms(this.areAlgorithmsActive)
  }

  async toggleAlgorithmActivation (algorithm: RuleEngineAlgorithm) {
    if (!algorithm.id) {
      return
    }
    const isUpdated = await this.updateRuleEngineAlgorithm({ id: algorithm.id, isActive: !algorithm.isActive })
    if (isUpdated) {
      await this.loadAlgorithms(this.areAlgorithmsActive)
    }
  }

  get algorithmActions (): DataTableAction<RuleEngineAlgorithm>[] {
    return [
      {
        text: this.areAlgorithmsActive ? 'כיבוי' : 'הפעלה',
        icon: 'mdi-power',
        handler: this.toggleAlgorithmActivation.bind(this)
      },
      {
        text: 'עריכה',
        icon: 'mdi-pencil',
        handler: this.editAlgorithm.bind(this)
      }

    ]
  }

  get formattedAlgorithms () {
    return this.ruleEngineAlgorithms.map(alg => ({
      ...alg,
      trigger: translate(alg.trigger || '')
    }))
  }

  get isAlgorithmSavedMessageVisible (): boolean {
    return !!this.algorithmSavedMessage
  }

  set isAlgorithmSavedMessageVisible (value: boolean) {
    if (!value) {
      this.algorithmSavedMessage = ''
    }
  }
}
